export default __webpack_public_path__ + "static/media/back-icon.16a3a35e.svg";